import { Route } from "react-router-dom";

import RootPage from "../components/root";
import LoginPage from "../views/login";
import { HomePage } from "../views/home";
import { Level } from "../views/level";
import { Mine } from "../views/mine";


import { settingsRouters } from "./routers/settings";
import { cardRouters } from "./routers/card";
import { memberRouters } from "./routers/member";
import { amountRouters } from "./routers/amount";
import { otherRouters } from "./routers/other";
import { safeBoxRouters } from "./routers/safeBox"

import { langPage } from "../locales";

interface router {
  path: string;
  component: any;
  exact?: boolean;
  name?: string;
  meta?: object,
  children?: Array<router>;
}

export const routers: Array<router> = [
  {
    path: "/login",
    name: "login",
    component: LoginPage
  },
  {
    path: "/",
    component: RootPage,
    meta: {
      privilegeCode: 1
    },
    children: [
      {
        path: "/home",
        name: "home",
        exact: true,
        component: HomePage,
        meta: {
          breadcrumb: [
            {
              name: langPage?.home?.name,
              path: ""
            },
          ],
          privilegeCode: "home",
        }
      },
      {
        path: "/level",
        name: "level",
        exact: true,
        component: Level,
        meta: {
          breadcrumb: [
            {
              name: langPage?.level.name,
              path: ""
            },
          ],
          privilegeCode: "level",
        }
      },
      {
        path: "/mine",
        name: "mine",
        exact: true,
        component: Mine,
        meta: {
          breadcrumb: [
            {
              name: langPage?.mine.name,
              path: ""
            },
          ],
          privilegeCode: "",
        }
      },
      ...memberRouters,
      ...settingsRouters,
      ...cardRouters,
      ...amountRouters,
      ...otherRouters,
      ...safeBoxRouters
    ]
  }
];

export const RouteWithSubRoutes = (route: any) => {
  return (
    <Route
      path={route.path}
      exact={route.exact}
      render={props => {
        return <route.component {...props} routes={route.children} />
      }}
    />
  )
};
